import { ROLLBAR_ENABLED, ROLLBAR_CLIENT_TOKEN } from '@/app/core/common/config';

export const isRollbarEnabled = () => ROLLBAR_CLIENT_TOKEN && ROLLBAR_ENABLED;
